export default __webpack_public_path__ + "static/media/bride.af16cf0e.jpg";